var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTrash(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 21,
    viewBox: "0 0 17 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.0001 3.83332H13.4167C13.018 1.89465 11.3126 0.5025 9.33339 0.5H7.66671C5.68745 0.5025 3.98206 1.89465 3.58339 3.83332H1.00007C0.539834 3.83332 0.166748 4.20641 0.166748 4.66664C0.166748 5.12687 0.539834 5.5 1.00007 5.5H1.83339V16.3333C1.83616 18.6334 3.70003 20.4973 6.00007 20.5H11.0001C13.3001 20.4973 15.164 18.6334 15.1667 16.3333V5.5H16.0001C16.4603 5.5 16.8334 5.12691 16.8334 4.66668C16.8334 4.20645 16.4603 3.83332 16.0001 3.83332ZM7.66675 14.6667C7.66675 15.1269 7.29366 15.5 6.83343 15.5C6.37315 15.5 6.00007 15.1269 6.00007 14.6667V9.66668C6.00007 9.20645 6.37315 8.83336 6.83339 8.83336C7.29362 8.83336 7.66671 9.20645 7.66671 9.66668V14.6667H7.66675ZM11.0001 14.6667C11.0001 15.1269 10.627 15.5 10.1667 15.5C9.70651 15.5 9.33343 15.1269 9.33343 14.6667V9.66668C9.33343 9.20645 9.70651 8.83336 10.1667 8.83336C10.627 8.83336 11.0001 9.20645 11.0001 9.66668V14.6667ZM5.30925 3.83332C5.6637 2.83523 6.60761 2.16793 7.66675 2.16664H9.33343C10.3926 2.16793 11.3365 2.83523 11.6909 3.83332H5.30925Z",
    fill: "#1E1E1E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrash);
export default __webpack_public_path__ + "static/media/trash.e5d0cc4ac1ffe9530baf0655e5857896.svg";
export { ForwardRef as ReactComponent };